import { createRegExpFromString } from "@jti/fe-common";
export const isInvalidPostCode = (postcode, { postcode_validation_enabled, postcode_is_required, postcode_min_length, postcode_max_length, postcode_validate_regex, }) => {
    if (!postcode_validation_enabled) {
        return false;
    }
    if (!postcode) {
        return postcode_is_required;
    }
    if ((postcode_min_length && postcode.length < postcode_min_length) ||
        (postcode_max_length && postcode.length > postcode_max_length)) {
        return true;
    }
    const fieldRegex = createRegExpFromString(postcode_validate_regex);
    if (fieldRegex && !fieldRegex.test(postcode)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=isInvalidPostCode.js.map